module.exports = "<div class=\"container backend-content\">\r\n\t<div class=\"row-wrapper\">\r\n\t\t<router-outlet name=\"menu\"></router-outlet>\r\n\t\t<section class=\"backend-content-right col\">\r\n\t\t\t<router-outlet></router-outlet>\r\n\t\t</section>\r\n\t</div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/sm-backend-layout.component.html
// module id = 462
// module chunks = 11